import {createSvgIcon} from "@buildwitt/shapeshift-common/v1/icon";

export const IconCourseVideos = createSvgIcon(
	<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9.75 12.5L16.75 8L9.75 3.5V12.5ZM6.25 16C5.7 16 5.22917 15.8042 4.8375 15.4125C4.44583 15.0208 4.25 14.55 4.25 14V2C4.25 1.45 4.44583 0.979167 4.8375 0.5875C5.22917 0.195833 5.7 0 6.25 0H18.25C18.8 0 19.2708 0.195833 19.6625 0.5875C20.0542 0.979167 20.25 1.45 20.25 2V14C20.25 14.55 20.0542 15.0208 19.6625 15.4125C19.2708 15.8042 18.8 16 18.25 16H6.25ZM6.25 14H18.25V2H6.25V14ZM2.25 20C1.7 20 1.22917 19.8042 0.8375 19.4125C0.445833 19.0208 0.25 18.55 0.25 18V4H2.25V18H16.25V20H2.25Z" fill="white" />
	</svg>,
	"CourseVideos",
	"0 0 21 20"
);